export default __webpack_public_path__ + "assets/hotgig-loading.d72fdd9e.png";